import React from 'react'
import { Slot } from 'radix-ui'

import { ampli } from '@/shared/lib/ampli'
import { useModals } from '@/shared/lib/modal-manager'

export const EditScenario = ({
	children,
	scenarioId,
}: {
	children: React.ReactNode
	scenarioId: string
}) => {
	const { showModal } = useModals()

	return (
		<Slot.Root
			onClick={() => {
				ampli.whatIfScenarioEditClicked()
				showModal('EDIT_SCENARIO', { scenarioId })
			}}
		>
			{children}
		</Slot.Root>
	)
}
